module.exports = __webpack_public_path__ + "img/weddings_26_H.1e240cbd.webp";